import React from 'react';

const HomePage = () => {
  return (
    <div className="login-container">
      <h1>💬 Добро пожаловать в чат!</h1>
      <p style={{ textAlign: 'center', marginTop: '20px' }}>
        Для входа в чат перейдите по ссылке на комнату
      </p>
    </div>
  );
};

export default HomePage;